import { InputTag } from 'mixs/base/input_mixin';
import { deepmerge } from 'utilities/merge';

export class SearchSwitch extends InputTag {
  defaultOpts = {
    negative_value: 0,
    positive_value: 1,
    class: 'checkbox-color checkbox-success'
  }
  init(){
    this.opts = deepmerge(this.defaultOpts, this.opts)
    super.init();
    this.watch();
  }
  public onChange(e){
    let value = e.target.checked ? this.opts.positive_value : this.opts.negative_value;
    this.dispatch({value: value})
  }
}
riot.mixin('inputs.search.switch', SearchSwitch as riot.TagMixin)
